module.exports = __webpack_public_path__ + "img/top-back.28fa50ce.png";